import { useSelector } from 'react-redux';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_RESOURCE_CRON_HISTORY_REQUEST } from 'js/constants/actionTypes';
import has from 'lodash/has';
import { CRON_HISTORY_PAGINATED } from 'js/constants/paginationEntitiesTypes';

export type ResourceCronItem = {
  dataSetId: number;
  errorCount: number;
  runId: number;
  runIdTime: string;
  recordCount: number;
  size: number;
};

type Result = {
  items: ResourceCronItem[];
  meta: {
    currentPage: number;
    totalCount: number;
    pageCount: number;
    orderBy: string;
    groupBy: string;
  };
  loading: boolean;
};

export function useResourceCronHistory(type, id): Result {
  const { data } = useSelector((state: any) => state?.pagination);
  const loading = useIsLoading(GET_RESOURCE_CRON_HISTORY_REQUEST);

  if (has(data, [CRON_HISTORY_PAGINATED, type, id, 'metrics'])) {
    const metrics = data[CRON_HISTORY_PAGINATED][type][id]?.metrics;
    const meta = metrics?.meta;
    const items = metrics?.data;
    return { items, meta, loading };
  }
  // @ts-ignore
  return { items: [], meta: {}, loading: false };
}
